import { cx } from "class-variance-authority";
import { FiAlertTriangle } from "react-icons/fi";
import { IndicatorProps, indicatorSizes } from "./types";

interface ErrorIndicatorProps extends IndicatorProps {
  className?: string;
}
export const ErrorIndicator = (props: ErrorIndicatorProps) => {
  return (
    <p className={cx("flex", props.className ?? "")}>
      <FiAlertTriangle
        className={cx(
          "text-magenta",
          indicatorSizes[props.indicatorSize].iconSize,
        )}
      />
      &nbsp;&nbsp;
      <span
        className={cx(
          "text-inter text-medium-hippo",
          indicatorSizes[props.indicatorSize].messageSize,
        )}
      >
        {props.message}
      </span>
    </p>
  );
};
